import i18n from '@i18n';
import * as yup from 'yup';

export const validationSchema = () =>
  yup.object({
    name: yup.string().trim().required(i18n.t('VALIDATION.REQUIRED')),
    // order_by: yup.string().required(Validation['VALIDATION.REQUIRED']),
  });
